import { useState } from 'react';
import { formSubmissionsApi } from '../services/api/formSubmissions';

export function useFormSubmission() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const submitForm = async (formData) => {
    try {
      setLoading(true);
      setError(null);
      const response = await formSubmissionsApi.submit(formData);
      return response;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return {
    submitForm,
    loading,
    error,
  };
}
